import axios from "../axios";
import h from "../helpers";
import { clientIp } from "../api-address";

const purchaseOrder = {
  index: async (params) => {
    const { data } = await axios.get(h.baseUrl("purchase-orders"), {
      params: { ...params },
    });
    return data;
  },
  show: async (id) => {
    const { data } = await axios.get(h.baseUrl("purchase-orders/" + id));
    return data;
  },
  store: async (items) => {
    const { data } = await axios.post(h.baseUrl("purchase-orders"), {
      items,
      ip_address: await clientIp(),
    });
    return data;
  },
  update: async (id, status) => {
    const { data } = await axios.put(h.baseUrl("purchase-orders/" + id), {
      status,
      ip_address: await clientIp(),
    });
    return data;
  },
  delete: async (id) => {
    const ip = await clientIp();
    const { data } = await axios.delete(
      h.baseUrl("purchase-orders/" + id + `?ip_address=${ip}`)
    );
    return data;
  },
};

export default purchaseOrder;
